import React from "react";
import { Modal, Button } from "antd";
import FormCompetence from "../formCompetence/formCompetence";

const ModalCompetence = ({
    visible,
    onClose,
    states,
    setters,
    newCompetence,
    saveCompetence
}) => {
    return (
        <Modal
            title={newCompetence ? "Crear nueva competencia" : "Editar competencia"}
            open={visible}
            onCancel={onClose}
            footer={null}
            width="80%"
            maskClosable={false}
        >
            <FormCompetence
                {...states}
                {...setters}
                newCompetence={newCompetence}
                saveCompetence={saveCompetence}
            />
        </Modal>
    );
};

export default ModalCompetence;
